"use client";

import { SideNav } from "@/components/SideNav";
import { SellerPage } from "@/components/SellerPage";
import { SERVICE_PAUSED } from "@/config/service";
import { ServicePausedNotice } from "@/components/ServicePausedNotice";

export default function SellerPageClient() {
  return (
    <>
      <SideNav />
      {SERVICE_PAUSED ? <ServicePausedNotice /> : <SellerPage />}
    </>
  );
}
